export default __webpack_public_path__ + "static/media/about_img-2.662a4807.jpg";